import React from 'react';
import ReactDOM from 'react-dom/client';

import {
  Layout
} from '@douyinfe/semi-ui';

import App
  from './App';

import JingmuHeader
  from './components/JingmuHeader';

import {
  ThemeProvider
} from './context/Theme';

import reportWebVitals
  from './reportWebVitals';

import 'semantic-ui-css/semantic.min.css';

import './index.css';
import './jingmu-theme.css';


const root =
  ReactDOM.createRoot(
    document.getElementById('root')
  );

const {
  Content
} = Layout;


root.render(

  <ThemeProvider>

    <JingmuHeader />

    <Layout
      className="jm-app-layout"
    >

      <Content
        className="jm-key-content"
      >

        <App />

      </Content>

    </Layout>

  </ThemeProvider>

);


document.title =
  '鲸木 API｜令牌额度查询';


reportWebVitals();
